import { ItemWithTranslation } from 'types/swagger';

/* eslint-disable no-unused-vars */
export enum ScommessaKind {
  ScommesseTipoAntepost = 'ScommesseTipoAntepost',
  ScommesseTipoEsitiOverThree = 'ScommesseTipoEsitiOverThree',
  ScommesseTipoEsitiUnderThree = 'ScommesseTipoEsitiUnderThree',
  ScommesseTipoWithInfoAggMultiple = 'ScommesseTipoWithInfoAggMultiple',
  ScommesseTipoEsitiOverThreeEstesa = 'ScommesseTipoEsitiOverThreeEstesa',
  ScommesseTipoEsitiOverThreeWithInfoAgg = 'ScommesseTipoEsitiOverThreeWithInfoAgg',
  ScommesseTipoEsitiUnderThreeWithInfoAgg = 'ScommesseTipoEsitiUnderThreeWithInfoAgg',
  ScommesseTipoEsitiUnderThreeWithBilanciata = 'ScommesseTipoEsitiUnderThreeWithBilanciata',
  ScommesseTipoEsitiOverThreeWithInfoAggEstesa = 'ScommesseTipoEsitiOverThreeWithInfoAggEstesa',
  ScommesseTipoEsitiUnderThreeWithInfoAggEstesa = 'ScommesseTipoEsitiUnderThreeWithInfoAggEstesa',
}
/* eslint-enable no-unused-vars */

export type ScommessaKindType = `${ScommessaKind}`;

export type ScommesseTipoProps = ItemWithTranslation<{ header?: string }> & {
  isEstesa?: boolean;
  hasHeader?: boolean;
  scommessaKey: string;
  infoAggiuntivaKey?: string;
  showOnlyBilanciata?: boolean;
  gtagAction?: () => void;
};

export type DynamicScommessaTipoProps = ScommesseTipoProps & {
  scommessaTipo?: ScommessaKindType;
};
